import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EssencialRoutingModule } from './essencial-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from '../../shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { MantenerJerarquiaEssencialComponent } from './view/mantener-jerarquia-essencial/mantener-jerarquia-essencial.component';
import { CsvValidarEssencialComponent } from './view/csv-validar-essencial/csv-validar-essencial.component';
import { MantenerGrupoVendedoresB2CComponent } from './view/mantener-grupo-vendedores-b2-c/mantener-grupo-vendedores-b2-c.component';

@NgModule({
  declarations: [
    MantenerJerarquiaEssencialComponent,
    CsvValidarEssencialComponent,
    MantenerGrupoVendedoresB2CComponent,
  ],
  exports:[
    MantenerJerarquiaEssencialComponent,
    CsvValidarEssencialComponent,
    MantenerGrupoVendedoresB2CComponent,
  ],
  imports: [
    CommonModule,
    EssencialRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent, LfsaBotonsGridComponent]),
  ]
})
export class EssencialModule { }
